var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg018Empty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1660.9 1468.8",
    style: {
      enableBackground: "new 0 0 1660.9 1468.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#20B198;}\r\n\t.st2{fill:#D2E6FF;}\r\n\t.st3{fill:#32C7A0;}\r\n\t.st4{fill:#F6576A;}\r\n\t.st5{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -491.3,
    y: -509.2,
    className: "st0",
    width: 2500,
    height: 2500
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M556.6,193.2l-3.9,7.9c-25.7,51.9-78.6,84.7-136.4,84.7h-264C68.2,285.8,0,353.9,0,438v559.3 c0,84.1,68.2,152.2,152.2,152.2h958.7c84.1,0,152.2-68.2,152.2-152.2V540.4V285.8v-25c0-84.1-68.2-152.2-152.2-152.2H693.1 C635.2,108.5,582.3,141.3,556.6,193.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "197.1,1204.6 56.5,1115.7 468.9,1115.7 468.9,1204.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1209.4,1042.6H123.9c-37.2,0-67.4-30.2-67.4-67.4V80.2c0-37.2,30.2-67.4,67.4-67.4h1085.5 c37.2,0,67.4,30.2,67.4,67.4v895.1C1276.8,1012.5,1246.7,1042.6,1209.4,1042.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M685.1,273.2l-3.9,7.9c-25.7,51.9-78.6,84.7-136.4,84.7h-264c-84.1,0-152.2,68.2-152.2,152.2v559.3 c0,84.1,68.2,152.2,152.2,152.2h958.7c84.1,0,152.2-68.2,152.2-152.2V620.4V365.8v-25c0-84.1-68.2-152.2-152.2-152.2H821.5 C763.7,188.5,710.8,221.3,685.1,273.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1241,
    cy: 1048.9,
    r: 419.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1336.9,1048.9l111-111c16.4-16.4,16.4-42.9,0-59.3l-36.6-36.6c-16.4-16.4-42.9-16.4-59.3,0l-111,111 l-111-111c-16.4-16.4-42.9-16.4-59.3,0l-36.6,36.6c-16.4,16.4-16.4,42.9,0,59.3l111,111l-111,111c-16.4,16.4-16.4,42.9,0,59.3 l36.6,36.6c16.4,16.4,42.9,16.4,59.3,0l111-111l111,111c16.4,16.4,42.9,16.4,59.3,0l36.6-36.6c16.4-16.4,16.4-42.9,0-59.3 L1336.9,1048.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg018Empty);
export default __webpack_public_path__ + "static/media/018-empty.f14843479136fd13249f0735b5ee5217.svg";
export { ForwardRef as ReactComponent };